import axios from 'axios'


let search  = axios.create({
    baseURL:'',//发请求的接口地址
    timeout:6000//发请求在多长时间会超时
})

export default search



// WEBPACK FOOTER //
// ./src/util/fetch.js